export default function moneyMask(number) {
  if (!number) return '';
  const stringToNumber = parseInt(number, 10);
  return new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(stringToNumber);
}
